import type { BlobCandidate } from '~/types/pipeline';
import { discoverBlobs as detectBlobs } from './detect';

/**
 * Thin call-site shim around the synchronous CCL detector. Exists so a future
 * worker route (if profiling demands it) becomes a one-line swap without
 * touching every caller.
 */
export function discoverBlobs(
  img: ImageData,
  opts: { alphaThreshold: number; minArea: number },
): BlobCandidate[] {
  return detectBlobs(img, opts);
}
